import styled from 'styled-components';
import { Box, BoxProps } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { THUMB_HEIGHT, THUMB_WIDTH } from '../ProductSnippet/constants';
import { UnavailableProductSnippetProps } from './typings';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'UnavailableProductSnippet' })
    .attrs<UnavailableProductSnippetProps>((props) => ({
        ...props,
        direction: 'row',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--control-secondary-background)',
        borderRadius: 3,
        p: props.p || 0.5,
        pr: props.pr || 1,
        spacing: 2,
    }))``;

export const ImageWrapper = styled(Box)
    .withConfig({ displayName: 'ImageWrapper' })
    .attrs<BoxProps>((props) => ({
        ...props,
        height: THUMB_HEIGHT,
        width: THUMB_WIDTH,
        minWidth: THUMB_WIDTH,
        borderRadius: '20px',
        backgroundColor: 'var(--background-primary)',
        overflow: 'hidden',
    }))`
    align-content: center;
`;
